import { ModalName } from '@/shared/store/modals/constants';
import { showModalAction } from '@/shared/store/modals/actions';
import { UserSupply } from '@/shared/store/supplies';
import { Agreement } from '@/shared/api/borrow';
import { toast } from '@/shared/hooks/useToast';

export const handleWithdraw =
    (dispatch: any, item: UserSupply, agreement: Agreement, refresh: () => void) => () => {
        if (!agreement?.poolBalance) {
            refresh();

            return toast({
                title: 'There was an error to get the agreement balance',
                variant: 'error',
            });
        }

        if (agreement.version === 2) {
            return dispatch(
                showModalAction({
                    modalName: ModalName.POOLS_WITHDRAWAL_V2_MODAL,
                    modalTitle: 'Withdraw Liquidity',
                    modalProps: {
                        balance: item.balance,
                        currentApy: Number(item.apy),
                        totalBorrowed: agreement.totalBorrowed,
                        totalDepositThreshold: item.totalDepositThreshold,
                        isWithdraw: true,
                        agreementAddress: item.agreementAddress,
                        tokenAddress: item.tokenAddress,
                        tokenSymbol: item.tokenSymbol,
                        decimals: item.tokenDecimals,
                        totalPosition: agreement?.totalPosition,
                        totalProfit: agreement?.totalProfit,
                        lpTokenBalance: agreement?.lpTokenBalance,
                        totalAssets: agreement.totalAssets,
                        assetsFetched: agreement.assetsFetched,
                        poolUtilization: agreement?.poolUtilization,
                        poolBalance: agreement?.poolBalance,
                        refresh,
                    },
                }),
            );
        }

        if (!item.totalDeposited) {
            refresh();

            return toast({
                title: 'There was an error to get the total deposited',
                variant: 'error',
            });
        }

        dispatch(
            showModalAction({
                modalName: ModalName.POOLS_WITHDRAWAL_MODAL,
                modalTitle: 'Withdraw Liquidity',
                modalProps: {
                    balance: item.balance,
                    currentApy: Number(item.apy),
                    totalDeposited: item.totalDeposited,
                    totalDepositThreshold: item.totalDepositThreshold,
                    isWithdraw: true,
                    agreementAddress: item.agreementAddress,
                    tokenAddress: item.tokenAddress,
                    tokenSymbol: item.tokenSymbol,
                    decimals: item.tokenDecimals,
                    interestClaimable: agreement?.interestClaimable,
                    totalPosition: agreement?.totalPosition,
                    interestAccrued: agreement?.interestAccrued,
                    poolUtilization: agreement?.poolUtilization,
                    poolBalance: agreement?.poolBalance,
                    refresh,
                },
            }),
        );
    };
